var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInquiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5835 16.8933H11.9168L7.83765 19.6066C7.23265 20.0099 6.41683 19.5791 6.41683 18.8458V16.8933C3.66683 16.8933 1.8335 15.06 1.8335 12.31V6.8099C1.8335 4.0599 3.66683 2.22656 6.41683 2.22656H15.5835C18.3335 2.22656 20.1668 4.0599 20.1668 6.8099V12.31C20.1668 15.06 18.3335 16.8933 15.5835 16.8933Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 10.4141V10.2216C11.0002 9.59826 11.3852 9.26825 11.7702 9.00242C12.146 8.74575 12.5218 8.41576 12.5218 7.81076C12.5218 6.96743 11.8435 6.28906 11.0002 6.28906C10.1568 6.28906 9.47852 6.96743 9.47852 7.81076",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9957 12.6048H11.004",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquiry);
export default __webpack_public_path__ + "static/media/inquiry.5b225a4d5225278296806d3aa55622db.svg";
export { ForwardRef as ReactComponent };